import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var PhotoIcon = function PhotoIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    strokeColor = _props.strokeColor,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.338 18",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("g", {
    fill: fillColor,
    stroke: (_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : strokeColor,
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1")
  }, [h("path", {
    d: "M12.934.5a2.581 2.581 0 0 1 1.827.755l1.5 1.5a2.572 2.572 0 0 0 \n                1.825.756h1.172a2.583 2.583 0 0 1 2.582 2.582v8.827a2.582 2.582 0 0 \n                1-2.584 2.58H3.081A2.582 2.582 0 0 1 .5 14.918V6.092A2.582 2.582 0 0 \n                1 3.081 3.51h1.172a2.572 2.572 0 0 0 1.825-.756l1.494-1.5A2.583 2.583 0 0 1 9.4.5Z"
  }), h("path", {
    d: "M7.882 10.61a3.284 3.284 0 1 1 3.288 3.29 3.283 3.283 0 0 1-3.288-3.29Z"
  }), h("path", {
    d: "M4.77 7a.741.741 0 1 1-.741-.739h0A.739.739 0 0 1 4.77 7"
  })])]);
};